<nz-modal
  (nzOnCancel)="closeDrawer()"
  (nzOnOk)="edit()"
  [nzClosable]="true"
  [nzCloseIcon]="closeIconTpl"
  [nzOkDisabled]="form.invalid || editMutation.isPending()"
  [nzOkLoading]="editMutation.isPending()"
  [nzVisible]="show"
  nzOkText="Update Parcel Item Type"
>
  <ng-template #closeIconTpl>
    <div class="mt-4">
      <span class="fa fa-close"></span>
    </div>
  </ng-template>
  <div *nzModalTitle><span class="fe fe-edit"></span> Edit Parcel Type</div>
  <div *nzModalContent>
    <app-error-display *ngIf="showError() && errorDetails" [error]="errorDetails" (dismiss)="onDismissError()" (retry)="edit()"></app-error-display>
    
    <div class="mb-4 p-3 bg-blue-50 border border-blue-200 rounded">
      <p class="text-xs text-blue-800">
        <strong>💡 Note:</strong> Changes to default cost will only affect new routes. Existing routes keep their current pricing.
      </p>
    </div>

    <form [formGroup]="form" class="grid grid-cols-2 gap-4">
      <nz-form-item class="col-span-2">
        <nz-form-label [nzRequired]="true">Category Name</nz-form-label>
        <nz-form-control nzErrorTip="Category name is required">
          <input
            formControlName="category"
            nz-input
            type="text"
            placeholder="e.g., Small Box"
            [disabled]="editMutation.isPending()"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="col-span-2">
        <nz-form-label [nzRequired]="true">Description</nz-form-label>
        <nz-form-control nzErrorTip="Description is required">
          <input
            formControlName="description"
            nz-input
            type="text"
            placeholder="e.g., Small packages and boxes"
            [disabled]="editMutation.isPending()"
          />
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Max Weight (kg)</nz-form-label>
        <nz-form-control nzErrorTip="Weight cannot be negative">
          <input
            formControlName="maxWeight"
            nz-input
            type="number"
            step="0.1"
            min="0"
            placeholder="0 (no limit)"
            [disabled]="editMutation.isPending()"
          />
          <div class="text-xs text-gray-500 mt-1">
            0 means no weight limit
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label>Max Volume (m³)</nz-form-label>
        <nz-form-control nzErrorTip="Volume cannot be negative">
          <input
            formControlName="maxVolume"
            nz-input
            type="number"
            step="0.001"
            min="0"
            placeholder="0 (no limit)"
            [disabled]="editMutation.isPending()"
          />
          <div class="text-xs text-gray-500 mt-1">
            0 means no volume limit
          </div>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item class="col-span-2">
        <nz-form-label [nzRequired]="true">Default Cost (UGX)</nz-form-label>
        <nz-form-control nzErrorTip="Cost must be 0 or greater">
          <input
            formControlName="defaultCost"
            nz-input
            type="number"
            step="1000"
            min="0"
            placeholder="e.g., 10000"
            [disabled]="editMutation.isPending()"
          />
          <div class="text-xs text-gray-500 mt-1">
            Used as initial cost when adding this parcel item type to new routes.
          </div>
        </nz-form-control>
      </nz-form-item>
    </form>
  </div>
</nz-modal>

